module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "orders-buyer-information"
  }, [_c('div', {
    staticClass: "buyer-infos"
  }, [_c('span', {
    staticClass: "buyer buyer-name"
  }, [_vm._v("Joe Smith")]), _vm._v(" "), _c('span', {
    staticClass: "buyer buyer-email"
  }, [_vm._v("E-mail: joe.smith@loreal.com")]), _vm._v(" "), _c('span', {
    staticClass: "buyer buyer-phone"
  }, [_vm._v("Tel: +033 (0)6 12 12 12")]), _vm._v(" "), _c('span', {
    staticClass: "buyer buyer-order"
  }, [_c('span', {
    staticClass: "orderNbr"
  }, [_vm._v("7")]), _vm._v(" Orders "), _c('button', {
    staticClass: "btn-orders"
  }, [_vm._v("View order history")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-def76e84","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/order-common/order-buyer-information.vue
// module id = 3381
// module chunks = 0